import { useLocation } from 'react-router-dom';

export const useQuery = () => new URLSearchParams(useLocation().search);

export { useElementSize } from './useElementSize';
export { usePartnerConfig } from './usePartnerConfig';
export { useConsentCapture } from './useConsentCapture';
